import { AxiosError } from 'axios';
import { sortSymtomsByClassifications } from 'helpers/pet.helpers';
import { authHeader } from 'services';
import { ITreatmentOnGoing } from 'types';

import { Api } from './api/axios.service';

const IMAGE_URL = `${process.env.REACT_APP_BASE_API_URL}/api/pet/image-download`;
const BASE_URL = '/treatment-on-going';

/**
 * Get current treatment by logged vet
 *
 * @return {*}  {Promise<ITreatmentOnGoing>}
 */
const getCurrentTreatmentOnGoing = async (): Promise<ITreatmentOnGoing> => {
  try {
    const headers = authHeader();

    const { data } = await Api.get<ITreatmentOnGoing>(
      `${BASE_URL}/current-treatment-on-going-by-vet`,
      {
        headers,
      }
    );

    if (!data) {
      throw new Error();
    }

    /* Get complete pet image with authentication */
    if (data.pet.image) {
      data.pet.imageUrl = `${IMAGE_URL}/${data.pet._id}/?access_token=${headers.Authorization}`;
    }

    data.symptoms = sortSymtomsByClassifications(data.symptoms);

    return data;
  } catch (reason: any) {
    const { response } = reason as AxiosError<{ error: string }>;

    throw new Error(
      response?.data?.error || 'Não foi possível obter os dados do atendimento'
    );
  }
};

const downloadImage = async (treatmentId: any, documentId: any): Promise<any> => {
  try {
    const headers = authHeader();

    const response = await Api.get<any>(
      `${BASE_URL}/downloadContent/${treatmentId}/${documentId}`,
      {
        headers,
        responseType: 'arraybuffer'
      }
    );

    if (!response) {
      throw new Error();
    }
    return Buffer.from(response.data).toString("base64");
  } catch (reason: any) {
    const { response } = reason as AxiosError<{ error: string }>;

    throw new Error(
      response?.data?.error || 'Não foi possível obter os dados do atendimento'
    );
  }
};

interface IFinishTreatmentOnGoing {
  treatmentId: string;
  roomId: string;
}
/**
 * Finish treatment on going by vet
 *
 * @param {IFinishTreatmentOnGoing} data
 * @return {*}  {Promise<void>}
 */
const finishTreatmentOnGoing = async (
  data: IFinishTreatmentOnGoing
): Promise<void> => {
  try {
    const headers = authHeader();

    await Api.put(`${BASE_URL}/finish-treatment-on-going-vet`, data, {
      headers,
    });
  } catch (reason: any) {
    const { response } = reason as AxiosError<{ error: string }>;

    throw new Error(
      response?.data?.error || 'Não foi possível encerrar o atendimento'
    );
  }
};

export const TreatmentOnGoingService = {
  getCurrentTreatmentOnGoing,
  finishTreatmentOnGoing,
  downloadImage
};
